import { PropsWithChildren, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Button } from '../../global/button/Button'
import { useScrollToElementIds } from '../../hooks/useScrollToElementIds'
import { ChevronDownIcon } from '../../icons/ChevronDownIcon'
import { Link } from '../../navigation/custom-react-router-dom'
import { PageHeader } from '../../ui/Table/Header/PageHeader'
import { Text, TextH3, TextLargeStrong, TextStrong } from '../../ui/Typography/Typography'

import styles from './Accordion.module.scss'

export const AccordionList: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.gettingStarted}>
      <PageHeader title={t('Learning.Getting Started')} />
      <div className={styles.titleSection}>
        <TextH3>{t('Learning.Quick guidelines')}</TextH3>
        <Text>{t('Learning.Congratulations! You have registered with Tickmill')}</Text>
      </div>
      <div className={styles.accordionsBox}>{children}</div>
    </div>
  )
}

export interface AccordionProps {
  title: string
  subtitle: string
  text?: string | React.ReactNode
  path?: string
  icon: React.ReactNode
  buttonText?: string
  accordionId?: string
}

export const Accordion: React.FC<AccordionProps> = (props) => {
  const { title, subtitle, path, icon, buttonText, text, accordionId } = props

  const [isOpen, setIsOpen] = useState(false)

  const { scrollIntoView } = useScrollToElementIds()

  useEffect(() => {
    if (isOpen && accordionId) {
      scrollIntoView([accordionId])
    }
  }, [isOpen, accordionId, scrollIntoView])

  return (
    <div className={styles.accordion} id={accordionId}>
      <div className={styles.titleBox} onClick={() => setIsOpen(!isOpen)}>
        <TextLargeStrong>{title}</TextLargeStrong>
        <div
          className={classNames(styles.chevron, {
            [styles.chevronUp]: isOpen,
            [styles.chevronDown]: !isOpen,
          })}
        >
          <ChevronDownIcon size={24} />
        </div>
      </div>
      <div
        className={classNames(styles.content, {
          [styles.open]: isOpen,
        })}
      >
        <div className={styles.innerContent}>
          <div className={styles.leftSection}>
            {subtitle && <TextStrong>{subtitle}</TextStrong>}
            {text && <Text>{text}</Text>}
            {buttonText && path && (
              <Link to={path}>
                <Button className={styles.button} appearance='primary' size='M'>
                  {buttonText}
                </Button>
              </Link>
            )}
          </div>
          <div className={styles.rigthSection}>{icon}</div>
        </div>
      </div>
    </div>
  )
}
